
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("dmo0c", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ef97e2a7771397a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $8jqPJ = parcelRequire("8jqPJ");
const $ef97e2a7771397a2$var$LegacyIssueCreateTrackers = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8jqPJ.useAnalyticsEvents)();
    const trackLegacyIssueCreate = (0, $eUqFw.useCallback)((event)=>{
        if (!(event instanceof CustomEvent)) return;
        const payload = event.detail;
        const trackEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireTrackAnalytics)(trackEvent, 'issueCreated inProductSurvey', payload.objectId, {
            ...payload.attributes
        });
    }, [
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        document.addEventListener('legacy_legacyIssueCreated', trackLegacyIssueCreate);
        return ()=>document.removeEventListener('legacy_legacyIssueCreated', trackLegacyIssueCreate);
    }, [
        createAnalyticsEvent,
        trackLegacyIssueCreate
    ]);
    return null;
};
var $ef97e2a7771397a2$export$2e2bcd8739ae039 = $ef97e2a7771397a2$var$LegacyIssueCreateTrackers;

});


//# sourceMappingURL=async-legacy-issue-create-trackers.be13fd06.js.map
